module.exports = __webpack_public_path__ + "static/990-15e10e4050d3e7de97c0f15d9b1d730b.png";